import clsx from 'clsx';
import React, { useState } from 'react';
import ItemsCarousel from './ItemsCarousel';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import CustomCarouselControls from '../../Shared/components/CustomCarouselControls';

const CarouselMode = ({ sitecoreContext, rewards, swiperRef }) => {
  //images
  const rightArrow = '/-/media/Project/FAB2/Fab2/data/media/svgs/gallery/icon-arrow-right';
  const leftArrow = '/-/media/Project/FAB2/Fab2/data/media/svgs/gallery/icon-arrow-left';
  //swiper button
  const [nextDisabled, setNextDisabled] = useState(false);
  const [prevDisabled, setPrevDisabled] = useState(true);
  return (
    <div className={clsx('swiper-wrap')}>
      <CustomCarouselControls
        classname="navigation-custom"
        rightArrow={rightArrow}
        leftArrow={leftArrow}
        totalItems={rewards?.length}
        nextDisabled={nextDisabled}
        prevDisabled={prevDisabled}
        swiperRef={swiperRef}
      />
      <ItemsCarousel
        items={rewards}
        language={sitecoreContext.language}
        setPrevDisabled={setPrevDisabled}
        setNextDisabled={setNextDisabled}
        swiperRef={swiperRef}
      />
    </div>
  );
};

export default withSitecoreContext()(CarouselMode);
